import { carbonBankSubmissionsStore } from "../stores";

export const useCarbonBankSubmissionsStore = () => carbonBankSubmissionsStore;
